<template>
  <div>
    <add-note-form :start-lines="2" :date-picker="true" :contactId="contact.id"></add-note-form>
    <br />
    <ul class="list-padded" v-if="contact.notes.length > 0">
      <li v-for="note in contact.notes" :key="note.id">
        <i class="fas fa-thumbtack text-muted" v-if="note.pinned_at" /> {{ note.note }}
        <div class="text-muted">
          <small>
            <em>{{ note.date | dateString }}</em> |
            <em><a @click="editNote(note)">Edit Note</a></em> |
            <em><a class="text-danger" @click="deleteNote(note.id)">Delete Note</a></em>
          </small>
        </div>
      </li>
    </ul>
    <edit-contact-note-modal :id="editNoteId" @close="showEditModal = false" v-if="showEditModal" />
  </div>
</template>

<script>
import ContactsService from '../../services/ContactsService'
import { formsMixin } from '../../mixins/forms/formsMixin'
import AddNoteForm from './AddNoteForm'
import EditContactNoteModal from '../../views/Contacts/EditContactNoteModal'

export default {
  components: {
    EditContactNoteModal,
    AddNoteForm
  },
  mixins: [
    formsMixin
  ],
  props: {
    contact: {}
  },
  data () {
    return {
      addNoteSubmitError: null,
      newNote: '',
      isTypingNote: false,
      isProcessingNote: false,
      editNoteId: null,
      showEditModal: false
    }
  },
  methods: {
    async editNote (note) {
      this.editNoteId = note.id
      this.showEditModal = true
    },
    async deleteNote (contactNoteId) {
      if (!confirm('Are you sure that you want to DELETE this note?')) {
        return
      }
      try {
        await ContactsService.deleteContactNote(this.contact.id, contactNoteId)
      } catch (e) {
        this.addNoteSubmitError = e
      }
    }
  }
}
</script>
